import type { SettingsSource } from '@pypestream/ui-patterns';

/**
 * Where an org's inherited value is set: its parent's tab. When the value comes
 * from further up, the parent's page shows it with a pill of its own, so the
 * chain stays walkable without knowing every ancestor's account id.
 */
export const maestroSourceHref = (
  source: SettingsSource | null,
  parentId: string | null | undefined,
  section: 'ai-models' | 'voice'
): string | undefined =>
  source?.scopeType === 'org' && parentId
    ? `/organization/${parentId}/edit/${section}`
    : undefined;
